import React from "react";
import styles from "../Why_and_Safety/Why_and_Safety.module.css";
import Why_Us_Data from "../../Data/RO-landing.json";

const Why_and_Safety = () => {
  let Why_Us_Img = Why_Us_Data[0].banner1;
  let Safety_Img = Why_Us_Data[0].banner2;

  return (
    <div className={styles.container}>
      <img src={Why_Us_Img.webImg} alt={Why_Us_Img.altText} />
      <img src={Safety_Img.webImg} alt={Safety_Img.altText} />
    </div>
  );
};

export default Why_and_Safety;
